<div class="group-item-edit-popup-container">
  <h2 mat-dialog-title>{{ isEditMode ? 'Edit Group Item' : 'Add New Group Item' }}</h2>

  <mat-dialog-content class="dialog-content">
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-text">Loading...</div>
    </div>

    <form [formGroup]="editForm" *ngIf="!isLoading" class="edit-form">
      <!-- Always Show Checkbox -->
      <!-- <div class="always-show-container">
        <mat-checkbox>Always Show</mat-checkbox>
      </div> -->

      <!-- Basic Information -->
      <div class="form-row">
        <mat-form-field class="form-fields">
          <mat-label>Code</mat-label>
          <input matInput formControlName="code" maxlength="10" [readonly]="isEditMode">
          <mat-error *ngIf="editForm.get('code')?.hasError('required')">Code is required</mat-error>
          <mat-error *ngIf="editForm.get('code')?.hasError('maxlength')">Maximum length is 10</mat-error>
        </mat-form-field>

        <mat-form-field class="form-field">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" maxlength="50">
          <mat-error *ngIf="editForm.get('name')?.hasError('required')">Name is required</mat-error>
          <mat-error *ngIf="editForm.get('name')?.hasError('maxlength')">Maximum length is 50</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field class="form-field">
          <mat-label>Item Class</mat-label>
          <mat-select formControlName="itemClass">
            <mat-option *ngFor="let itemClass of itemClasses" [value]="itemClass.id">
              {{ itemClass.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="editForm.get('itemClass')?.hasError('required')">Item class is required</mat-error>
        </mat-form-field>

        <mat-form-field class="form-field">
          <mat-label>Display Order</mat-label>
          <input matInput type="number" formControlName="displayOrder">
          <mat-error *ngIf="editForm.get('displayOrder')?.hasError('required')">Display order is required</mat-error>
          <mat-error *ngIf="editForm.get('displayOrder')?.hasError('pattern')">Only numbers are allowed</mat-error>
        </mat-form-field>
      </div>
      <div class="content-container">
        <div style="display: flex;gap: 10px;align-items: center;">
          <div class="sub-title">
            Display Colors
          </div>
          <div>
            <mat-checkbox formControlName="useMultiColor">Use
              Multicolor?</mat-checkbox>
          </div>
        </div>
        <div class="color-container">
          <mat-form-field class="color-chooser fg-color">
            <mat-label>Foreground color</mat-label>
            <input matInput type="color" formControlName="foregroundColor">
          </mat-form-field>
          <mat-form-field class="color-chooser bg-color">
            <mat-label>Background Color @if(isMultiColorEnabled) {<span>1</span>}</mat-label>
            <input matInput type="color" formControlName="backgroundColor">
          </mat-form-field>
          @if(isMultiColorEnabled) {
          <mat-form-field class="color-chooser bg-color">
            <mat-label>Background Color 2</mat-label>
            <input matInput type="color" formControlName="backgroundColor2">
          </mat-form-field>
          }
        </div>
      </div>
      <!-- Multi Color Section -->
      <!-- <div class="color-section">
        <mat-checkbox formControlName="useMultiColor">Use Multi Color</mat-checkbox>

        <div class="color-inputs">
          <div class="color-row">
            <label>Background Color</label>
            <input type="color" formControlName="backgroundColor" class="color-input">
          </div>

          <div class="color-row">
            <label>Foreground Color</label>
            <input type="color" formControlName="foregroundColor" class="color-input">
          </div>

          <div class="color-row" *ngIf="isMultiColorEnabled">
            <label>Background Color 2</label>
            <input type="color" formControlName="backgroundColor2" class="color-input">
          </div>
        </div>
      </div> -->

      <!-- Hot Items Section -->
      <div class="hot-items-section">
        <table class="hot-items-table">
          <thead>
            <tr>
              <th class="row-label-header"></th>
              <th class="hot-item-header">HOT ITEM 1</th>
              <th class="hot-item-header">HOT ITEM 2</th>
              <th class="hot-item-header">HOT ITEM 3</th>
              <th class="hot-item-header">DRIVE THROUGH</th>
            </tr>
          </thead>
          <tbody>
            <tr class="enabled-row">
              <td class="row-label">Enabled</td>
              <td class="checkbox-cell">
                <mat-checkbox formControlName="hotItem1Enabled" color="primary"></mat-checkbox>
              </td>
              <td class="checkbox-cell">
                <mat-checkbox formControlName="hotItem2Enabled" color="primary"></mat-checkbox>
              </td>
              <td class="checkbox-cell">
                <mat-checkbox formControlName="hotItem3Enabled" color="primary"></mat-checkbox>
              </td>
              <td class="checkbox-cell">
                <mat-checkbox formControlName="driveThoughEnabled" color="primary"></mat-checkbox>
              </td>
            </tr>
            <tr class="display-order-row">
              <td class="row-label">Display Order</td>
              <td class="input-cell">
                <mat-form-field class="hot-item-input">
                  <input matInput formControlName="hotItem1DisplayOrder" type="number" class="center-input">
                </mat-form-field>
              </td>
              <td class="input-cell">
                <mat-form-field class="hot-item-input">
                  <input matInput formControlName="hotItem2DisplayOrder" type="number" class="center-input">
                </mat-form-field>
              </td>
              <td class="input-cell">
                <mat-form-field class="hot-item-input">
                  <input matInput formControlName="hotItem3DisplayOrder" type="number" class="center-input">
                </mat-form-field>
              </td>
              <td class="input-cell">
                <mat-form-field class="hot-item-input">
                  <input matInput formControlName="driveThoughDisplayOrder" type="number" class="center-input" [disabled]="!editForm.get('driveThoughEnabled')?.value">
                </mat-form-field>
              </td>
            </tr>
            <tr class="menu-number-row">
              <td class="row-label">Menu Number</td>
              <td class="input-cell gray-bg"></td>
              <td class="input-cell gray-bg"></td>
              <td class="input-cell gray-bg"></td>
              <td class="input-cell">
                <mat-form-field class="hot-item-input">
                  <input matInput formControlName="driveThoughMenuNumber" type="number" class="center-input">
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </mat-dialog-content>

  <div class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-button">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" class="submit-button">
      {{ isEditMode ? 'Update' : 'Create' }}
    </button>
  </div>
</div>
<!-- </div> -->
<!-- </form> -->
<!-- </mat-dialog-content> -->

<!-- <div class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-button">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" class="submit-button">Submit</button>
  </div> -->
<!-- </div> -->